import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import { Loader2, Store } from "lucide-react";

export default function Settings() {
  const [store, setStore] = useState(null);

  useEffect(() => { api.get("/store").then((r) => setStore(r.data)).catch(() => {}); }, []);
  const set = (k) => (e) => setStore({ ...store, [k]: e.target.value });

  const save = async () => {
    try {
      await api.put("/store", {
        name: store.name, address: store.address, phone: store.phone,
        currency: store.currency, logo: store.logo, receipt_footer: store.receipt_footer,
        tax_rate: Number(store.tax_rate) || 0,
      });
      toast.success("Pengaturan disimpan");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  if (!store) return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-5 max-w-2xl" data-testid="settings-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Pengaturan Toko</h1>
        <p className="text-muted-foreground text-sm">Informasi toko yang tampil pada struk dan laporan.</p>
      </div>

      <Card className="p-6 border-slate-200 rounded-xl shadow-sm space-y-4">
        <div className="flex items-center gap-3 pb-4 border-b border-slate-100">
          <div className="w-12 h-12 rounded-lg bg-accent text-primary flex items-center justify-center"><Store className="w-6 h-6" /></div>
          <div><div className="font-heading font-bold text-lg">{store.name}</div><div className="text-xs text-muted-foreground">ID: {store.id}</div></div>
        </div>
        <div><Label>Nama Toko</Label><Input value={store.name} onChange={set("name")} className="mt-1 rounded-lg" data-testid="store-name-input" /></div>
        <div><Label>Alamat</Label><Input value={store.address || ""} onChange={set("address")} className="mt-1 rounded-lg" data-testid="store-address-input" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Telepon</Label><Input value={store.phone || ""} onChange={set("phone")} className="mt-1 rounded-lg" data-testid="store-phone-input" /></div>
          <div><Label>Mata Uang</Label><Input value={store.currency || "Rp"} onChange={set("currency")} className="mt-1 rounded-lg" /></div>
        </div>
        <div><Label>Catatan Struk</Label><Input value={store.receipt_footer || ""} onChange={set("receipt_footer")} className="mt-1 rounded-lg" placeholder="Terima kasih telah berbelanja!" /></div>
        <Button onClick={save} className="rounded-lg" data-testid="save-store-btn">Simpan Perubahan</Button>
      </Card>
    </div>
  );
}
